import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { Wordmark } from "@/components/Logo";
import { ContactDialog } from "@/components/ContactDialog";
import { useLang } from "@/context/LangContext";

export const Footer = () => {
  const { t } = useLang();
  const [contact, setContact] = useState(false);
  return (
  <footer className="bg-[#1C1917] text-stone-300" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-12 flex flex-col md:flex-row md:items-center justify-between gap-8">
      <div className="space-y-3">
        <Wordmark className="h-28" />
        <p className="text-sm leading-relaxed max-w-xs">{t.footer.desc}</p>
      </div>
      <div className="flex flex-wrap gap-6 text-sm">
        <Link to="/library" className="hover:text-white transition-colors" data-testid="footer-library-link">{t.nav.library}</Link>
        <Link to="/samples" className="hover:text-white transition-colors" data-testid="footer-samples-link">{t.nav.samples}</Link>
        <Link to="/register" className="hover:text-white transition-colors" data-testid="footer-register-link">{t.nav.register}</Link>
        <Link to="/login" className="hover:text-white transition-colors" data-testid="footer-login-link">{t.nav.login}</Link>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 pb-10 flex flex-col sm:flex-row sm:items-center gap-4" data-testid="footer-schools">
      <p className="text-white font-semibold">{t.footer.schools}</p>
      <button onClick={() => setContact(true)} data-testid="footer-contact-btn"
        className="self-start inline-flex items-center gap-2 rounded-full bg-amber-400 text-[#1C1917] px-5 py-2.5 text-sm font-bold hover:bg-amber-300 transition-colors">
        <Mail className="w-4 h-4" /> {t.footer.contactBtn}
      </button>
    </div>
    <ContactDialog open={contact} onOpenChange={setContact} />
    <div className="border-t border-stone-800 py-6 text-center text-xs text-stone-400">© 2026 يلّا هيرو Yalla Hero · {t.footer.rights}</div>
  </footer>
  );
};
